
    import '/home/ec2-user/Youlify-Design/docs/spec/motion.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-spec-motion-demo-en-us-0"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/home/ec2-user/Youlify-Design/docs/spec/motion.en-US.md?type=demo')
};